import './BrandsSearch.css';
import { BrandsSearchProps } from './BrandsSearch.types';

/**
 * Renders search input for filtering brands
 * Allows real-time search across brand names, IDs, and other properties
 *
 *
 */
export function BrandsSearch({ searchTerm, onSearchChange }: BrandsSearchProps): JSX.Element {
  return (
    <div className="brands-search-container">
      <input
        placeholder="Пошук по брендах..."
        value={searchTerm}
        onChange={e => onSearchChange(e.target.value)}
        className="brands-search-input"
      />
    </div>
  );
}
